/**
 * 后台展示项里分组充值任务浮标固定位（与首充 *_FIXED 一致），
 * activityId 不再是 taskGroupId，需用 activities.GROUPED_RECHARGE_TASK.list 合并；约定见 groupedRechargeBonusFields.ts。
 */
export function isGroupedRechargeTaskFloatingFixedId(
  activityId: string | undefined
): boolean {
  if (!activityId) return false;
  return (
    activityId === "GROUPED_RECHARGE_TASK_FIXED" ||
    (activityId.startsWith("GROUPED_RECHARGE") && activityId.endsWith("_FIXED"))
  );
}

/**
 * 后台每条 list 项可有 countdownTime（剩余毫秒，null/缺省/≤0 表示该档不展示倒计时候选）。
 * 多档时与「先结束的是谁」一致：取剩余毫秒最小（时间最近）的一条。
 */
export function getMinPositiveGroupedRechargeCountdownMs(
  tasks: readonly { countdownTime?: number | null }[] | null | undefined
): number {
  if (!tasks?.length) return 0;
  const vals: number[] = [];
  for (const t of tasks) {
    const v = t?.countdownTime;
    if (v == null) continue;
    const n = Number(v);
    if (Number.isFinite(n) && n > 0) vals.push(n);
  }
  if (vals.length === 0) return 0;
  return Math.min(...vals);
}
